import { render, staticRenderFns } from "./bindTemplate.vue?vue&type=template&id=27a7eea5&"
import script from "./bindTemplate.vue?vue&type=script&lang=js&"
export * from "./bindTemplate.vue?vue&type=script&lang=js&"
import style0 from "./bindTemplate.vue?vue&type=style&index=0&id=27a7eea5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports